import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=237e4f0e&name=product-item&"
import script from "./ProductItem.vue?vue&type=script&lang=js&"
export * from "./ProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=237e4f0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports